(function () {
  const wrap = document.querySelector('.design-templates-wrapper[data-section-id]');
  if (!wrap) return;
  const sectionId = wrap.getAttribute('data-section-id');
  const grid = wrap.querySelector('#dt-cards[data-infinite-grid]');
  const dataEl = wrap.querySelector('#dt-data');
  const sentinel = wrap.querySelector('#dt-sentinel');
  const spinner = wrap.querySelector('.infinite-spinner');
  if (!grid || !dataEl || !sentinel) return;

  let nextUrl = dataEl.getAttribute('data-next-url');
  let loading = false;

  async function loadNext() {
    if (!nextUrl || loading) return;
    loading = true; spinner.hidden = false;
    try {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('sections', sectionId);
      const res = await fetch(url.toString(), { credentials: 'same-origin' });
      const json = await res.json();
      const html = json[sectionId];
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('#dt-cards[data-infinite-grid]');
      if (newGrid) Array.from(newGrid.children).forEach(el => grid.appendChild(el));

      const newData = doc.querySelector('#dt-data');
      nextUrl = newData ? newData.getAttribute('data-next-url') : null;
      if (!nextUrl && observer) observer.disconnect();
    } catch (e) { console.error(e); }
    finally { spinner.hidden = true; loading = false; }
  }

  const observer = new IntersectionObserver(
    entries => entries.forEach(e => { if (e.isIntersecting) loadNext(); }),
    { rootMargin: '600px 0px 600px 0px' }
  );
  observer.observe(sentinel);
})();
